




















import AccountSettings from '@/mixins/accountSettings.mixin';
import Component from 'vue-class-component';
import { Mixins, Prop } from 'vue-property-decorator';
import APP_CONST from '@/constants/AppConst';

@Component
export default class DashboardNavIcon extends Mixins(AccountSettings) {
  @Prop(String) readonly href!: string;
  @Prop(String) readonly alt!: string;
  @Prop({ type: String, default: '0 0 48 48' }) readonly viewBox!: string;
  @Prop({ type: Boolean, default: false }) readonly fillPath!: boolean;

  APP_CONST = APP_CONST;

  get isActive(): boolean {
    return this.$route && this.$route.path == this.href;
  }
}
